import { forwardRef } from 'react';
import { BadgeProps } from './badge.types';
import { SVG } from 'components/svg';
import { BadgeContainer } from './badge.styled';
import { Icons } from 'assets';

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  (
    {
      mode = 'primary',
      variant = 'secondary',
      shape = 'round',
      size = 's',
      icon,
      disabled,
      children,
      ...rest
    },
    forwardedRef
  ) => {
    return (
      <BadgeContainer
        ref={forwardedRef}
        $shape={shape}
        $size={size}
        $variant={variant}
        $mode={mode}
        data-disabled={disabled}
        {...rest}
      >
        {icon && (
          <div>
            <SVG src={Icons[icon]} />
          </div>
        )}

        <span>{children}</span>
      </BadgeContainer>
    );
  }
);
